import React, { memo } from 'react'

import { graphql } from 'gatsby'

import Img from '../components/Img'

const Awards = ({ slice }) => (
  <ul className="awards">
    {slice?.items.map((item) => (
      <li key={item} className="awards-item">
        <Img
          image={item?.award?.gatsbyImageData}
          alt={item?.alt}
          className="mobile-thumbnail"
        />
      </li>
    ))}
  </ul>
)

export default memo(Awards)

export const query = graphql`
  fragment FooterDataBodyAwards on PrismicFooterDataBodyAwards {
    id
    items {
      award {
        gatsbyImageData
      }
    }
  }
`
